import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import * as serviceWorker from './serviceWorker';

import {Provider} from 'react-redux';
import {configureStore} from './redux/store';
import ReduxToastr from "react-redux-toastr";

ReactDOM.render(
    <Provider store={configureStore()}>
        <App/>
        <div>
            <ReduxToastr
                timeOut={3000}
                newestOnTop={false}
                preventDuplicates
                position="top-center"
                getState={(state) => state.toastr} // This is the default
                transitionIn="bounceIn"
                transitionOut="fadeOut"
                // progressBar
                // closeOnToastrClick
            />
        </div>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();

